import { Routes } from '@angular/router';
import { loginGuard } from './guards/login.guard';
import { AuthGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./pages/auth/auth.routes').then(m => m.routes),
    canActivate: [loginGuard]
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/private/private.routes').then(m => m.routes),
    loadComponent: () => import('./pages/private/private.component').then(m => m.PrivateComponent),
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    redirectTo: 'auth/login',
  }
];
